import React from "react";
import { Link, useLocation } from "react-router";
import { ReportDetails } from "@sscs/types";
import { ReportNavigationState } from "Types";
import styles from "./linkToReport.module.scss";
import useReportNavigation from "./useReportNavigation";

type LinkToReportProps = {
  id?: string;
  type?: "link" | "text";
  report: ReportDetails;
  goToPage?: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

const LinkToReport = ({
  id,
  type = "link",
  report,
  goToPage,
  className,
  onClick,
  children,
}: LinkToReportProps): React.JSX.Element => {
  const { pathname, search } = useLocation();
  const { reportLink, searchParams } = useReportNavigation(report);
  const navigationState: ReportNavigationState = {
    from: `${pathname}${search}`,
  };

  return (
    <Link
      id={id}
      to={`${reportLink}/${goToPage ?? ""}?${searchParams}`}
      state={navigationState}
      className={`${styles[type]} ${className}`}
      preventScrollReset
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default LinkToReport;
